module.exports = __webpack_public_path__ + "img/airtime-to-cash.c6c46982.jpeg";